import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Badge,
  Row,
  Col,
  Button,
  Card,
  Table,
  DropdownItem,
  DropdownMenu,
  UncontrolledCollapse,
  DropdownToggle,
  Dropdown,
  FormGroup,
  Input,
  Tooltip,
} from "reactstrap";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import { authHeader } from "../../../functions/CoreFunctions";
import { debounce } from "underscore";
import API from "../../../redux/actions/API";
import {
  AGENCY_CUSTOMER_PAYMENT_REPORT,
  STATE_LIST,
} from "../../../constants/ApiPaths";
import { getAgencyId } from "../../common/CommonFunctions";
import Pagination from "react-js-pagination";
import moment from "moment";
import generatePDF from "./CustomerPaymentGenerator";
import { CSVLink } from "react-csv";
import ProfileAvatar from "../../../images/user logo.png";
import { Info } from "../../common/Info";

export default function AgencyCustomerPaymentReport() {
  const [dropdownOpen, setdropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [PaymentReport, setPaymentReport] = useState([]);
  const [totalrecords, settotalrecords] = useState(0);
  const [currentpage, setCurrentPage] = useState(0);
  const [userName, setuserName] = useState("");
  let rowperpage = 10;

  const [SelectState, setSelectState] = useState([]);
  const [filterState, setfilterState] = useState("");
  const [paymentType, setpaymentType] = useState("");
  const [paymentStatus, setpaymentStatus] = useState("");
  const [paymentDate, setpaymentDate] = useState("");
  const [data, setdata] = useState([]);
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const toggle = () => {
    setdropdownOpen(!dropdownOpen);
  };
  const headers = [
    { label: "Name", key: "userName" },
    { label: "Payment Type", key: "paymentType" },
    { label: "Total Amount", key: "totalAmount" },
    { label: "Payment Date", key: "paymentDate" },
    { label: "Payment Status", key: "paymentStatus" },
  ];

  let getCustomerPaymentReport = async (
    userName,
    filterState,
    paymentType,
    paymentDate,
    paymentStatus
  ) => {
    setLoading(true);
    const config = {
      method: "GET",
      url: AGENCY_CUSTOMER_PAYMENT_REPORT,
      headers: authHeader(),
      params: {
        agencyId: getAgencyId(),
        count: rowperpage,
        offset: currentpage,
        email: userName,
        stateName: filterState,
        paymentType: paymentType,
        paymentDate: paymentDate,
        paymentStatus: paymentStatus,
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setPaymentReport(data);
        const value = data.map((data) => ({
          userName: data.userName,
          paymentType: data.paymentType,
          totalAmount: "$ " + data.totalAmount,
          paymentDate: data.paymentDate,
          paymentStatus: data.paymentStatus,
        }));
        setdata(value);
        settotalrecords(totalCount);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  let GetState = async () => {
    setLoading(true);
    const config = {
      method: "Get",
      url: STATE_LIST,
      headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setSelectState(data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const onPageChange = (page) => {
    setCurrentPage(page - 1);
  };

  let UserHandle = (e) => {
    setCurrentPage(0);
    setuserName(e.target.value);
  };

  let StateHandle = (e) => {
    setCurrentPage(0);
    setfilterState(e.target.value);
  };

  let paymetnHandle = (e) => {
    setCurrentPage(0);
    setpaymentType(e.target.value);
  };
  let datefilterHandle = (e) => {
    setCurrentPage(0);
    setpaymentDate(moment(e.target.value).format("MM/DD/YY"));
  };

  let PaymentStatus = (e) => {
    setCurrentPage(0);
    setpaymentStatus(e.target.value);
  };

  let Clear = () => {
    setuserName("");
    setfilterState("");
    setpaymentType("");
    setpaymentDate("");
    setpaymentStatus("");
  };

  let Export = () => {
    generatePDF(PaymentReport);
  };

  const AgencySearch = useRef(
    debounce((userName, filterState, paymentType, paymentDate, paymentStatus) =>
      getCustomerPaymentReport(
        userName,
        filterState,
        paymentType,
        paymentDate,
        paymentStatus
      )
    )
  ).current;

  useEffect(() => {
    GetState();
  }, []);

  useEffect(() => {
    AgencySearch(
      userName,
      filterState,
      paymentType,
      paymentDate,
      paymentStatus
    );
  }, [userName, filterState, paymentType, paymentDate, paymentStatus]);

  useEffect(() => {
    getCustomerPaymentReport(
      userName,
      filterState,
      paymentType,
      paymentDate,
      paymentStatus
    );
  }, [currentpage]);

  return (
    <div className="agency-wrapper">
      {loading && <CustomPageLoading />}

      <Container fluid>
        <div className="page-title">
          <h4>
            Customer Payment Report
            <Tooltip
              isOpen={id === "customerpayment" && tooltipOpen}
              target={"customerpayment"}
              toggle={() => tooltiptoggle("customerpayment")}
            >
              Customer payment report information
            </Tooltip>
            <span id={"customerpayment"}>
              <Info />
            </span>
          </h4>

          <div className="top-btn">
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle color="danger" caret>
                Export
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={Export}>PDF</DropdownItem>
                <DropdownItem>
                  <CSVLink
                    filename={"Customer_payment_report.csv"}
                    data={data}
                    headers={headers}
                  >
                    CSV
                  </CSVLink>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <Button id="toggler" color="link">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14.371"
                height="14.371"
                viewBox="0 0 14.371 14.371"
              >
                <path
                  id="Icon_awesome-filter"
                  data-name="Icon awesome-filter"
                  d="M13.7,0H.674A.674.674,0,0,0,.2,1.15L5.389,6.342v5.784a.674.674,0,0,0,.287.552l2.246,1.571a.674.674,0,0,0,1.06-.552V6.342L14.173,1.15A.674.674,0,0,0,13.7,0Z"
                  fill="#1b3e6f"
                />
              </svg>
            </Button>
          </div>
        </div>

        <div className="mt-4">
          <UncontrolledCollapse toggler="#toggler">
            <Card body>
              <Row className="mt-3">
                <Col md="6" lg="4" xl="3">
                  <span>Search Email</span>
                  <FormGroup>
                    <Input
                      value={userName}
                      placeholder="Enter Email"
                      onChange={UserHandle}
                      type="text"
                    />
                  </FormGroup>
                </Col>
                <Col md="6" lg="4" xl="3">
                  <FormGroup>
                    <span>Select State</span>
                    <Input
                      type="select"
                      name="stateId"
                      value={filterState}
                      onChange={StateHandle}
                      id=""
                    >
                      <option value="">Select State</option>
                      {SelectState.map((i) => (
                        <option key={i.stateId} value={i.stateName}>
                          {i.stateName}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md="6" lg="4" xl="3">
                  <FormGroup>
                    <span>Select Payment Type</span>
                    <Input
                      type="select"
                      name="stateId"
                      value={paymentType}
                      onChange={paymetnHandle}
                      id=""
                      placeholder="Enter hyperlink"
                    >
                      <option value="">Select Payment Type</option>
                      {["Debit Card", "Swipe"].map((i) => (
                        <option key={i} value={i}>
                          {i}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md="6" lg="4" xl="3">
                  <FormGroup>
                    <span>Search Payment Date</span>
                    <Input
                      type="date"
                      onChange={datefilterHandle}
                      value={moment(paymentDate).format("YYYY-MM-DD")}
                      name=""
                      id=""
                      placeholder="Email"
                    />
                  </FormGroup>
                </Col>
                <Col md="6" lg="4" xl="3">
                  <FormGroup>
                    <span>Select Payment Status</span>
                    <Input
                      value={paymentStatus}
                      onChange={PaymentStatus}
                      type="select"
                    >
                      <option value="">Select Payment Status</option>
                      <option value="Success">Success</option>
                      <option value="Failed">Failed</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md="6" lg="4" xl="3">
                  <Button color="danger" onClick={Clear} className="mt-4">
                    Clear
                  </Button>
                </Col>
              </Row>
            </Card>
          </UncontrolledCollapse>
        </div>

        <Card body className="mt-4">
          <Table hover responsive>
            <thead>
              <tr>
                <th>Name</th>
                <th>Address</th>
                <th>State</th>
                <th>Payment Date</th>
                <th>Total Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                ""
              ) : (
                <>
                  {PaymentReport.length === 0 ? (
                    <tr>
                      <td colSpan={9}>
                        <center>No Record Found</center>
                      </td>
                    </tr>
                  ) : (
                    <>
                      {PaymentReport.map((report, index) => (
                        <tr>
                          <td>
                            {" "}
                            <div className="user-box">
                              <img
                              alt=""
                                src={
                                  report.profileImage
                                    ? report.profileImage
                                    : ProfileAvatar
                                }
                              />
                              {` `}
                              {report.userName ? report.userName : "N/A"}
                            </div>
                          </td>
                          <td>{report.address ? report.address : "N/A"}</td>
                          <td>{report.state ? report.state : "N/A"}</td>
                          <td>
                            {report.paymentDate ? report.paymentDate : "N/A"}
                          </td>
                          <td>
                            {" "}
                            $ {parseFloat(report.totalAmount || 0).toFixed(2)}
                          </td>
                          <td>
                            <Badge
                              color={
                                report.paymentStatus === "Success"
                                  ? "success"
                                  : "danger"
                              }
                            >
                              {report.paymentStatus}
                            </Badge>{" "}
                          </td>
                        </tr>
                      ))}
                    </>
                  )}{" "}
                </>
              )}
            </tbody>
          </Table>
          <div className="d-flex flex-row py-4 justify-content-end">
            <Pagination
              itemClass="page-item"
              linkClass="page-link"
              activePage={currentpage + 1}
              itemsCountPerPage={rowperpage}
              totalItemsCount={totalrecords}
              onChange={onPageChange}
            />
          </div>
        </Card>
      </Container>
    </div>
  );
}
